<template>
    <v-flex>
        <v-flex v-show="status">
            <div>
                <v-toolbar dark color="gradiente" v-show="!$vuetify.breakpoint.xsOnly">
                    <div >

                    </div>
                </v-toolbar>

            <v-toolbar height="130" v-show="!$vuetify.breakpoint.xsOnly">
                <v-flex xs12 md3 lg3 px-4>
                    <v-list-tile-content>
                            <v-list-tile-title><b>Nombre de la Encuesta </b></v-list-tile-title>
                            <v-list-tile-sub-title>
                                {{ title }}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                </v-flex>
                <v-flex xs12 md3 lg3 px-4>
                    <v-list light style="background-color: transparent;">
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <v-icon >account_circle</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <b>{{visitType}}</b>
                                <v-list-tile-sub-title>
                                    {{ visitantName }}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex xs12 md3 lg3 px-4>
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <v-icon >event</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title><b>Fecha</b></v-list-tile-title>
                            <v-list-tile-sub-title>
                                {{ day }}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-flex>  
            </v-toolbar>

            <v-toolbar height="130" style="background:white" v-show="$vuetify.breakpoint.xsOnly">
                <v-flex xs12 md3 lg3 style="text-align: center;">
                    <p><b>Encuesta:</b>{{" "+ title }}</p>
                    <p><b>{{visitType}}:</b>{{" "+ visitantName}}</p>
                    <p><b>Fecha</b>:{{" "+ day }}</p>
                </v-flex>
                
            </v-toolbar>
        </div>

        <v-container id="scrolling-home" class="scroll-y scrollDesign overflow-y-auto contenQues" style="height: 79vh;">
            <div v-for="(question, i) in questions" :key="i" id="question-id" :class="{ 'cardsQuestion2': $vuetify.breakpoint.xsOnly, 'cardsQuestion': !$vuetify.breakpoint.xsOnly }">
                <v-flex xs12 mt-1 >
                    <v-layout row wrap style="justify-content: center;">
                        <v-card  width= "100%" style="border-radius: 15px; border: 0px !important; box-shadow: none;">
                            <v-card-title  class="white--text">
                                <h2 class="text-h5" style="color:#EB5860">{{ question.question }}</h2>
                                <v-spacer></v-spacer>
                            </v-card-title>
                
                            <div v-show="question.type=='MULTIPLE'" style="margin-bottom: 2%;">
                                <div v-for="(answer, a) in question.answers" :key="a" >
                                    <v-layout wrap row class="questions-size">
                                        <v-flex xs12 md12 lg12 px-3 style="padding-top: 10px;">
                                            <!--HERE -->
                                            <label v-if="answer.answer !='No presenta síntomas'">
                                                <input type="checkbox"
                                                    :value= {idPollQuestionAnswer:answer.id,idPollResult:id,idQ:question.id}
                                                    v-model="multipleAnswer"
                                                    :disabled="disableAllQuestion"
                                                    @change="check($event, answer.answer, null)"      
                                                />
                                                <span class="check-box-effect-disable" style="margin-top: 10px;" v-if="disableAllQuestion"></span>
                                                <span class="check-box-effect" style="margin-top: 10px;" v-if="!disableAllQuestion"></span>
                                                <label :class="{ 'q_enable': !disableAllQuestion, 'q_disable': disableAllQuestion  }" style="padding-left: 10px; top: -6px; ">{{ answer.answer }} </label>
                                            </label>

                                            <label v-if="answer.answer =='No presenta síntomas'">
                                                <input type="checkbox"
                                                    :value= {idPollQuestionAnswer:answer.id,idPollResult:id,idQ:question.id}
                                                    v-model="multipleAnswer"
                                                    :disabled="false"
                                                    @change="check($event, answer.answer, {idPollQuestionAnswer:answer.id,idPollResult:id,idQ:question.id})"      
                                                />
                                                <span class="check-box-effect" style="margin-top: 10px;"></span>
                                                <label style="padding-left: 10px; top: -6px; color:#3f3f3f !important">{{ answer.answer }} </label>
                                            </label>


                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>

                        </v-card>
                    </v-layout>
                </v-flex>
            </div>
            <v-divider style="margin-bottom: 20px"/>
            <div :class="{ 'checkC1': $vuetify.breakpoint.xsOnly, 'checkC': !$vuetify.breakpoint.xsOnly }" style="margin-bottom:20px">
                <label>
                    
                    <input type="checkbox" 
                        :value= !keycondition 
                        v-model="keycondition"       
                    />
                    <span class="check-box-effect"></span>
                    <label class="q_enable" style="padding-left: 10px; top:-6px">Hago constar que he contestado de manera correcta todas las preguntas.</label>
                </label>
            </div>
            <v-divider style="margin-bottom: 20px"/>

            <div :class="{ 'bottonStyle1': $vuetify.breakpoint.xsOnly, 'bottonStyle': !$vuetify.breakpoint.xsOnly }">

                <v-btn
                    style="width: 150Px;"
                    color="gradiente"
                    class="white--text"
                    round
                    @click="pollSummit()"
                >Enviar</v-btn>
            </div>
            <div style="height:50px" v-show="$vuetify.breakpoint.xsOnly"></div>
        </v-container>

        </v-flex>
        <div data-app>
            <alerta 
                v-model="modals.alert" 
                :text="modals.Clave" 
                :title="modals.Title" 
                :cond="modals.Cond" 
                @cancelled="onCancel"
            ></alerta>
        </div>
    </v-flex>
</template>


<script>
import alerta from "./PollAlert.vue"
export default {
    components:{
        alerta, 
    },
    data () {
        return {
            questions: [],
            questions1: [],
            modals: {
                alert: false,
                Clave: "",
                Title: "",
                Cond: false,
            },
            id: "",
            a:0,
            status: false,
            firstName: "",
            lastName: "",
            visitantName: "",
            visitType:"",
            title: "",
            idVisitant: "",
            day: "",
            options: { year:'numeric', month:'numeric', day:'numeric', },
            answers: [],
            ans:[],
            multipleAnswer: [],
            simpleAnswer: [],
            text: [],
            pollCol: {},
            keycondition:false,
            complete:false,
            disableAllQuestion:false
        }
    },
  methods: {
    getPollC(id){
        this.$store
            //.dispatch("3071/visits/poll/7dc808fa-bb62-4090-ad6c-29b46e58e1c0")
            .dispatch("polls/getVisitPoll",id)
            .then((response) => {
                console.log("response");
                var cond = response.data.available;
                if (cond==true) {
                    this.status = true;
                    this.visitantName = response.data.visitantName
                    this.firstName = "-"//response.data.collaborator.firstName;
                    this.lastName = "-" //response.data.collaborator.lastName;
                    this.id = response.data.pollResultId;
                    this.pollID = response.data.id;
                    this.idVisitant = response.data.idVisitant;
                    this.title = response.data.title;
                    var date = new Date(response.data.createdAt)
                    this.day = date.toLocaleDateString('en-GB', this.options)
                    this.questions = response.data.questions;
                    this.questions1 = response.data.questions;

                    //Para el tipo
                    let rol_colabator = response.data.audience.webRoleIds.length;
                    let rol_external = response.data.audience.externals.length;
                    
                    if(rol_colabator > 0){
                        this.visitType = "Colaborador"
                    }
                    if(rol_external > 0){
                        this.visitType = "Invitado externo"
                    }

                    //this.visitType = response.data.visitantName

                }else{
                    this.status = false;
                    this.modals.Clave = "Esta encuesta ya ha sido contestada anteriormente, asegúrate de elegir las encuestas pendientes por contestar."
                    this.modals.alert = true;
                    this.modals.Cond = false;
                }
            })
            .catch((error) => {

                this.status = false
                let ErrorCode = error.response.data.code;
                console.log("ErrorCode", ErrorCode);
                
                if(ErrorCode === 1014){
                    this.modals.Title = ""
                    this.modals.Clave = "Esta encuesta ya ha sido contestada anteriormente, asegúrate de elegir las encuestas pendientes por contestar."
                    this.modals.Cond = false;
                    this.modals.alert = true;
                }

                else{
                

                        if(error.response.data.answeredAt){
                                    
                            let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                            let answerDate =  new Date(error.response.data.answeredAt).toLocaleString('es-MX', options);
                            let answerHours =  new Date(error.response.data.answeredAt).toLocaleTimeString();
                            console.log("Error Response", error.response.data);
                            console.log("Error Response", error.response.data);
                            this.modals.Title = "¡Encuesta No Disponible!"
                            this.modals.Clave = `Esta encuesta ya ha sido contestada el día ${answerDate} a las ${answerHours}`
                            this.modals.Cond = false;
                            this.modals.alert = true;
                        }

                        else{
                            this.modals.Title = "¡Encuesta No Disponible!"
                            this.modals.Clave = "Esta encuesta ya no se encuentra disponible."
                            this.modals.Cond = false;
                            this.modals.alert = true;
                        }
                }
            });
    },
    pollSummit(){
        this.ans = [];
        for (let index = 0; index < this.answers.length; index++) {
            this.ans.push(this.answers[index])
        }
        for (let index = 0; index < this.multipleAnswer.length; index++) {
            this.ans.push(this.multipleAnswer[index])
        }

        for (let index = 0; index < this.ans.length; index++) {
            if (this.ans[index] == null) {
                this.ans.splice(index,1) 
            }
        }
        this.pollCol.id =  this.id;
        this.pollCol.idVisitant = this.idVisitant; 
        this.pollCol.answers = this.ans;

        var rs = 0;

        for (let index = 0; index < this.questions1.length; index++) {
            for (let index1 = 0; index1 < this.ans.length; index1++) {
                if (this.ans[index1] != null) {
                    if (this.questions1[index].id == this.ans[index1].idQ) {
                        rs++;
                        index1 = this.ans.length;
                    }
                }
            }
        }

        if (this.questions1.length == rs) {
            if (this.keycondition == true) {
                for (let index = 0; index < this.pollCol.answers.length; index++) {
                    if (this.pollCol.answers[index] == null) {
                        this.pollCol.answers.splice(index,1)
                        index--; 
                    }
                }

                console.log("this.pollCol *** ", this.pollCol, this.pollID);

                let pollData = {data: this.pollCol, id: this.pollID};
                this.$store
                //.dispatch("polls/postColPoll",this.pollCol)
                .dispatch("polls/postVisitPoll",pollData)
                .then(() => {
                    this.modals.Title = "¡Encuesta realizada con éxito!"
                    this.modals.Clave = "Tus respuestas han sido enviadas con éxito, serán revisadas por un miembro correspondiente de la institución."
                    this.modals.Cond = false;
                    this.modals.alert = true;
                })
                .catch(() => {
                    this.modals.Title = "Problema al enviar respuestas"
                    this.modals.Clave = "Las respuestas no se pudieron enviar, inténtalo nuevamente."
                    this.modals.Cond = true;
                    this.modals.alert = true;
                });
            } else {
                this.modals.Clave = "Asegúrate de habilitar la casilla de constancia de respuestas correctas."
                this.modals.alert = true;
                this.modals.Cond = true;
            } 
        } else {
            this.modals.Clave = "Asegúrate de contestar todas las preguntas que se muestran en el formulario antes de enviar"
            this.modals.alert = true;
            this.modals.Cond = true;
        }
        rs = 0;
    },

    addToAns: function (event, data, index) {
        if (data.textAnswer != "") {
            this.answers.splice(index, 1, data);
        } else {
            this.answers[index].idQ = 0
        }
        
    },

	onCancel() {
		this.modals.alert = false;
		this.$forceUpdate();
	},

    //HERE
    check(event, answer, value){   
        let checkEvent = event.target.checked
        if(answer == "No presenta síntomas"){
            if(checkEvent){
                this.disableAllQuestion = true;
                this.multipleAnswer = [];
                this.multipleAnswer.push(value);
            }else{
                this.disableAllQuestion = false;
            }
        }

        console.log("multipleAnswer", this.multipleAnswer);


    },

},

    

    mounted() {
        this.getPollC(this.$route.params.id);
    },


}
</script>

<style>
.cardsQuestion {
    margin-top: 2%; 
    margin-bottom: 1%; 
    justify-content: center;
}
.cardsQuestion2 {
    margin-bottom: 5%;
    justify-content: center; 
}

.q_enable{
    color:#3f3f3f !important
}

.q_disable{
    color:#dcdcdc !important
}




.checkC{
    text-align: left;
    margin-left: 17px;
}
.checkC1{
    text-align: center;
    margin-bottom: 4%;
}
.checkboxAns{
    border-radius: 50%;
    cursor: pointer;
    height: 20px;
    width: 20px;
    margin: 8px;
}

.bottonStyle{
    margin-top: 2%;
    margin-bottom: 3%;
    text-align: left;
}
.bottonStyle1{
    text-align: left;
    margin-top: 5%;
}

label {
  color: #7e7e7e;
  cursor: pointer;
  position: relative;
}

label .check-box-effect {
  display: inline-block;
  position: relative;
  background-color: transparent;
  width: 25px;
  height: 25px;
  border: 2px solid #8c8c8c;
  border-radius: 10%;
}


label .check-box-effect-disable {
  display: inline-block;
  position: relative;
  background-color: #dcdcdc;
  width: 25px;
  height: 25px;
  border: 2px solid #dcdcdc;
  border-radius: 10%;
}


label .check-box-effect:before {
  content: "";
  width: 0px;
  height: 2px;
  border-radius: 2px;
  background: #626262;
  position: absolute;
  transform: rotate(45deg);
  top: 11px;
  left: 6px;
  transition: width 50ms ease 50ms;
  transform-origin: 0% 0%;
}

label .check-box-effect:after {
  content: "";
  width: 0;
  height: 2px;
  border-radius: 2px;
  background: #626262;
  position: absolute;
  transform: rotate(305deg);
  top: 15px;
  left: 8px;
  transition: width 50ms ease;
  transform-origin: 0% 0%;
}

label:hover .check-box-effect:before {
  width: 5px;
  transition: width 100ms ease;
}

label:hover .check-box-effect:after {
  width: 10px;
  transition: width 150ms ease 100ms;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]:checked + .check-box-effect {
  background-color: #eb5860 !important;
  transform: scale(1.25);
}

input[type="checkbox"]:checked + .check-box-effect:after {
  width: 10px;
  background: rgb(255, 255, 255);
  transition: width 150ms ease 100ms;
}

input[type="checkbox"]:checked + .check-box-effect:before {
  width: 5px;
  background: rgb(255, 255, 255);
  transition: width 150ms ease 100ms;
}

input[type="checkbox"]:checked:hover + .check-box-effect {
  background-color: #dcdcdc;
  transform: scale(1.25);
}

input[type="checkbox"]:checked:hover + .check-box-effect:after {
  width: 10px;
  background: #333;
  transition: width 150ms ease 100ms;
}

input[type="checkbox"]:checked:hover + .check-box-effect:before {
  width: 5px;
  background: #333;
  transition: width 150ms ease 100ms;
}


@media only screen and (max-width: 768px) {
    label .check-box-effect:after {
    background: #FFF;
    }

    label .check-box-effect:before {
        background: #FFF;
        }

}
</style>